import { useState, useEffect, RefObject } from 'react';

export default function useOnScreen<T extends HTMLElement>(
  ref: RefObject<T | null>,
  rootMargin = '0px'
) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    // Observe relative to scrollable parent
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { root: element.parentElement, rootMargin }
    );

    observer.observe(element);

    return () => {
      observer.unobserve(element);
    };
  }, [ref, rootMargin]);

  return isVisible;
}
